module.exports = __webpack_public_path__ + "static/image/history/m/201707@3x.ver2_0_2.jpg?a423eae2";